import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var templatePreviewRes;
export const templatePreviewTodo = createAsyncThunk('templatePreview', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'certificate_preview',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "certificate_data_id": id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return templatePreviewRes = res.data
    } catch (error) {
        return templatePreviewRes = error.response.data
    }
})